// pages/sections/ReviewPagination.js
// The first / prev / next / last pager under a review table (`rt-pagination`).
import React from 'react';

export const REVIEW_PAGE_SIZE = 25;

export default function ReviewPagination({ page, totalPages, rowCount, onPage }) {
  if (totalPages <= 1) return null;
  return (
    <div className="rt-pagination">
      <button disabled={page <= 1} onClick={() => onPage(1)} title="First page">«</button>
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} title="Previous page">‹</button>
      <span className="rt-page-info">Page {page} of {totalPages} ({rowCount} rows)</span>
      <button disabled={page >= totalPages} onClick={() => onPage(page + 1)} title="Next page">›</button>
      <button disabled={page >= totalPages} onClick={() => onPage(totalPages)} title="Last page">»</button>
    </div>
  );
}
